import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import mixpanel from "mixpanel-browser";

// Determine the app name from an environment variable.
// Ensure you set REACT_APP_HEROKU_APP_NAME in your environment (e.g., "okgather-dev" or "okgather-prod").
const appName = process.env.REACT_APP_HEROKU_APP_NAME || "okgather-prod";

// Select Sentry DSN based on the app name.
const sentryDsn = appName === "okgather-prod"
  ? process.env.REACT_APP_SENTRY_DSN || "https://1cd35e91a7cb24f455b533691b9999ac:0d5eb1be5da3ac49c1d286484e632d05@o4508905094971392.ingest.us.sentry.io/4508905095102464"
  : process.env.REACT_APP_SENTRY_DSN_DEV || "https://7edfd7e47554eb0d4d7930cf2ed9132b@o4508932628217856.ingest.us.sentry.io/4508932628414464";

// Initialize Sentry with performance tracing enabled using a tracesSampler function.
Sentry.init({
  dsn: sentryDsn
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
